<template>
  <div class="search-box">
    <!-- 动态筛选条件区域 - 使用配置驱动，减少重复代码 -->
    <div class="tabs">
      <template v-for="(filter, idx) in filterConfigs">
        <el-row :key="filter.field">
          <el-col :span="3"><span class="title">{{ filter.label }}></span></el-col>
          <el-col :span="21">
            <!-- 全部选项 -->
            <span :class="getItemClass(filter, getFilterAllValue(filter))"
              @click="handleFilterClick(filter, getFilterAllValue(filter))">
              全部
            </span>
            <!-- 动态选项列表 -->
            <span v-for="opt in filter.options" :key="getOptionValue(opt, filter)"
              :class="getItemClass(filter, getOptionValue(opt, filter))"
              @click="handleFilterClick(filter, getOptionValue(opt, filter))">
              {{ getOptionLabel(opt, filter) }}
            </span>
          </el-col>
        </el-row>
        <el-divider v-if="idx < filterConfigs.length - 1" :key="`divider-${filter.field}`" class="search_line" />
      </template>
    </div>

    <!-- 搜索操作栏：年份/科目/排序/关键词搜索 -->
    <div class="specialty-search">
      <el-select v-model="check.subject" placeholder="选科" style="width: 90px; margin-right: 30px" size="mini"
        @change="doSearch">
        <el-option label="物理组" :value="1" />
        <el-option label="历史组" :value="4" />
      </el-select>

      <el-select v-model="check.year" placeholder="年份" style="width: 90px; margin-right: 30px" size="mini"
        @change="doSearch">
        <el-option v-for="year in years" :key="year" :label="year + '年'" :value="year" />
      </el-select>

      <span class="span-name">专业名称：</span>
      <el-input placeholder="请输入专业名称" style="width: 180px; margin-right: 30px" v-model="check.specialty_name"
        size="mini" @keyup.enter.native="doSearch" clearable />

      <span class="span-name">院校名称：</span>
      <el-input placeholder="请输入院校名称" style="width: 180px; margin-right: 30px" v-model="check.name" size="mini"
        @keyup.enter.native="doSearch" clearable />

      <span class="span-name">排序方式：</span>
      <el-select v-model="check.score_order" placeholder="排序方式" style="width: 110px" class="round_select" size="mini"
        @change="doSearch">
        <el-option label="最低分升序" value="asc" />
        <el-option label="最低分降序" value="desc" />
      </el-select>

      <span class="search-btn" @click="doSearch">搜索</span>
    </div>
  </div>
</template>

<script>
import connditionalData from "@/assets/data/conditional-search";

export default {
  name: "SchoolFilter", // 组件命名，便于调试

  data() {
    return {
      // 年份列表（可配置范围）
      years: ["2025", "2024", "2023", "2022"],

      // 筛选表单数据（与原始结构完全一致，确保父组件兼容）
      check: {
        city_id: [],
        nature_id: null,
        school_type_id: [],
        schoolTipId: [],
        year: "2025",
        specialty_name: "",
        name: null,
        subject: 1,
        new_batch: null,
        score_order: "desc",
      },

      // 原始数据源
      cityList: connditionalData.city,
      schoolTypeList: connditionalData.typeList,
      schoolTipList: connditionalData.tipList,
      natureList: connditionalData.natureList,
    };
  },

  computed: {
    /**
     * 筛选条件配置（驱动模板渲染）
     * 降低模板重复代码，提升可维护性；若需新增筛选维度，仅需在此扩展
     */
    filterConfigs() {
      return [
        {
          label: "所属地区",
          field: "city_id",
          type: "multiple", // 多选（数组）
          options: this.cityList,
          valueKey: "city_code",
          labelKey: "city",
        },
        {
          label: "院校类型",
          field: "school_type_id",
          type: "multiple",
          options: this.schoolTypeList,
          valueKey: "id",
          labelKey: "name",
        },
        {
          label: "院校性质",
          field: "nature_id",
          type: "single", // 单选（null / id）
          options: this.natureList,
          valueKey: "id",
          labelKey: "name",
        },
        {
          label: "院校特色",
          field: "schoolTipId",
          type: "multiple",
          options: this.schoolTipList,
          valueKey: "id",
          labelKey: "name",
        },
        {
          label: "办学类型",
          field: "new_batch",
          type: "single",
          // 固定选项（非外部数据）
          options: [
            { label: "普通本科", value: 1 },
            { label: "专科（高职）", value: 2 },
          ],
          valueKey: "value",
          labelKey: "label",
        },
      ];
    },
  },

  methods: {
    /**
     * 获取筛选项的高亮样式类
     * @param {Object} filter 配置项
     * @param {any} val 选项对应的值
     */
    getItemClass(filter, val) {
      const { field, type } = filter;
      const current = this.check[field];
      if (type === "multiple") {
        // 多选：全部 或 选中项在数组中
        const isAll = val === null;
        if (isAll) return { item: true, act: current.length === 0 };
        return { item: true, act: current.indexOf(val) > -1 };
      } else {
        // 单选：直接比较值（全部和普通选项统一比较）
        return { item: true, act: current === val };
      }
    },

    /**
     * 获取全部选项对应的值（统一处理）
     * 多选全部 => []；单选全部 => null
     */
    getFilterAllValue(filter) {
      return filter.type === "multiple" ? [] : null;
    },

    /**
     * 获取选项的真实值
     */
    getOptionValue(opt, filter) {
      return opt[filter.valueKey];
    },

    /**
     * 获取选项的显示文本
     */
    getOptionLabel(opt, filter) {
      return opt[filter.labelKey];
    },

    /**
     * 统一处理筛选条件点击（替代原有冗长的 choose 方法）
     * @param {Object} filter 配置项
     * @param {any} val 选项值（多选全部传 []，单选全部传 null）
     */
    handleFilterClick(filter, val) {
      const { field, type } = filter;

      if (type === "multiple") {
        // 多选逻辑：全部 => 清空数组；否则 toggle 选中项
        if (val === null || (Array.isArray(val) && val.length === 0)) {
          this.check[field] = [];
        } else {
          const index = this.check[field].indexOf(val);
          if (index > -1) {
            this.check[field].splice(index, 1);
          } else {
            this.check[field].push(val);
          }
        }
      } else {
        // 单选逻辑：直接赋值（包含 null 情况）
        this.check[field] = val;
      }

      // 条件变更后立即触发搜索（与原始行为一致）
      this.$emit("onSearch", this.check);
    },

    /**
     * 触发搜索（供外部按钮、回车、下拉变更等调用）
     */
    doSearch() {
      // 对 name 字段做空值标准化：若为空字符串则转为 null（与原结构对齐）
      if (this.check.name === "") {
        this.check.name = null;
      }
      this.$emit("onSearch", this.check);
    },
  },
};
</script>

<style lang="less" scoped>
.search-box {
  margin: 0 0 20px;

  .tabs {
    color: #666666;
    letter-spacing: 2px;
    padding: 15px 0 0;
    margin-bottom: 20px;
    font-size: 16px;

    .title {
      color: #333333;
      font-weight: 500;
      text-align: center;
    }

    span {
      display: inline-block;
      padding: 0 6px;
      line-height: 26px;
      margin-bottom: 3px;
      margin-right: 6px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #2b7bf3;
        color: white;
      }
    }

    .act {
      background-color: #2b7bf3;
      color: #ffffff;
    }
  }

  .search_line {
    margin: 7px 0;
  }
}

.specialty-search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .el-input__inner {
    border-radius: 30px;
    border: rgb(174, 182, 174) 1px solid;
  }

  .span-name {
    display: inline-block;
    position: relative;
    top: 2px;
    margin-right: 4px;
    white-space: nowrap;
  }

  .search-btn {
    float: right;
    background: #2b7bf3;
    color: white;
    padding: 3px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: opacity 0.2s;
    margin-left: auto;

    &:hover {
      opacity: 0.85;
    }
  }
}

// 适配移动端或窄屏换行
@media (max-width: 992px) {
  .specialty-search {

    .span-name,
    .el-input,
    .el-select {
      margin-bottom: 8px;
    }
  }
}
</style>